<template>
  <div class="modal-container">
    <LsClickable
      track-id="gate_left_open_modal-close"
      class="modal-close-x"
      @click="close"
      @mouseover="closeColor = 'gray-secondary'"
      @mouseleave="closeColor = 'primary'"
    >
      <LsIcon type="close" :color="closeColor" />
    </LsClickable>
    <div style="min-height: 200px;">
      <div>
        <header class="modal-header">
          {{ t('gateOpenModal.title') }}
          <p>{{ t('gateOpenModal.subtitle') }}</p>
        </header>
        <section class="modal-body">
          <img src="../../assets/return_request/fido.png" alt="fido" />
          <p>{{ t('gateOpenModal.body') }}</p>
        </section>
        <footer class="modal-footer">
          <LsButton text="ok" track-id="gate_left_open_modal-ok" @click="close" />
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import { LsButton, LsClickable, LsIcon } from '@/components/common';

export default {
  name: 'GateLeftOpenModal',
  components: {
    LsIcon,
    LsClickable,
    LsButton,
  },
  data() {
    return {
      closeColor: 'primary',
    };
  },
  methods: {
    close() {
      this.$router.replace({ name: 'services' });
      this.$parent.close();
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-body {
  display: flex;
  align-items: center;
  img {
    height: 140px;
    width: 140px;
    min-width: 140px;
    margin-right: 30px;
  }
}
</style>
